import { Injectable } from '@angular/core';
import { environment } from '../../../services/app-settings.service';

const YENILEME_MS = 30 * 60 * 1000;
const YARDIM_URL = 'https://yardim.dabto.com';

/**
 * Yardımı hazır ekranlar: yardım sitesinin herkese açık /yardim/liste.json'u (yalnız ekran yolları, içerik yok).
 * Taslak ve yönetici sayfaları listede yoktur; sitede bir sayfa yayınlanınca o ekranda "?" kendiliğinden çıkar.
 * HttpClient ve fetch kullanılmaz: HttpClient interceptor'ı, window.fetch de GlobalAuthFetchService sarmalayıcısı
 * (libs/auth json-api-client-auth-init.service.ts) her isteğe Dabnet oturum anahtarını (Bearer) ekliyor; anahtar
 * yardım sitesine gitmesin. Düz XMLHttpRequest, çerezsiz.
 */
@Injectable({ providedIn: 'root' })
export class YardimListesiService {
  private liste: Promise<Set<string>> | null = null;
  private alinma = 0;

  hazirMi(form: string): Promise<boolean> {
    return this.al().then((l) => l.has(form.toLowerCase()));
  }

  private al(): Promise<Set<string>> {
    const taban = (environment.yardimUrl || YARDIM_URL).replace(/\/+$/, '');
    if (!this.liste || Date.now() - this.alinma > YENILEME_MS) {
      this.alinma = Date.now();
      this.liste = jsonAl(`${taban}/yardim/liste.json`)
        .then((j) => new Set<string>((j?.formlar ?? []).map((f: string) => String(f).toLowerCase())))
        .catch(() => {
          this.alinma = 0; // ağ hatası: bir sonraki başlıkta yeniden dene
          return new Set<string>();
        });
    }
    return this.liste;
  }
}

function jsonAl(adres: string): Promise<any> {
  return new Promise((coz, reddet) => {
    const x = new XMLHttpRequest();
    x.open('GET', adres);
    x.withCredentials = false;
    x.responseType = 'json';
    x.timeout = 10000;
    x.onload = () => (x.status === 200 ? coz(x.response) : reddet(new Error(`yardım listesi ${x.status}`)));
    x.onerror = x.ontimeout = () => reddet(new Error('yardım listesi alınamadı'));
    x.send();
  });
}
